export const buildBillingPriceImportDecisionsV814 = (preview) => {
  const decisions = {};
  (preview?.items || []).forEach((item) => {
    if (!item.ignored && item.requires_decision) {
      decisions[item.model_name] =
        item.committed_decision || item.default_decision || 'keep';
    }
  });
  return decisions;
};

export const summarizeBillingPriceImportSelectionsV814 = (
  preview,
  decisions
) => {
  const summary = { replace: 0, keep: 0, ignored: 0 };
  (preview?.items || []).forEach((item) => {
    if (item.ignored) {
      summary.ignored += 1;
      return;
    }
    if (
      item.requires_decision &&
      (decisions?.[item.model_name] || item.default_decision) !== 'replace'
    ) {
      summary.keep += 1;
      return;
    }
    summary.replace += 1;
  });
  return summary;
};
